export default __webpack_public_path__ + "static/media/tomcat.04886c79.svg";